"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatch = void 0;
var immutable_1 = require("immutable");
var option_1 = require("./option");
var tryCatch = function (f, fallback) { return function (a) {
    var results = (0, immutable_1.List)(Array.isArray(f) ? f : [f])
        .map(function (f) { return f(a); })
        .flatMap(function (l, n, i) { return (0, option_1.listFromOption)(l); });
    if (results.isEmpty())
        return fallback(a);
    return results.first();
}; };
exports.tryCatch = tryCatch;
